export const BLOG_CATEGORIES = [
  {
    code: 'articles',
    color: '#DA8B9A',
  },
  {
    code: 'guides',
    color: '#8583BA',
  },
];
